import { Module } from 'vuex';
import { CoreState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { CORE_ACTIONS } from './core.actions';
import { CORE_MUTATIONS } from './core.mutations';
import { getInitialCoreState } from './core.state';

export const CORE_MODULE: Module<CoreState, RootStoreState> = {
  namespaced: true,
  actions: CORE_ACTIONS,
  mutations: CORE_MUTATIONS,
  state: getInitialCoreState()
};
